import React from "react";

const Hero = props => {
  return (
    <section className={`hero ${props.color} ${props.size}`}>
      <div className="hero-body">
        <div className={`container is-fluid`}>{props.children}</div>
      </div>
    </section>
  );
};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/hero/Hero.js